import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkText?: string;
  linkTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkText,
  linkTo,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 border-b border-background-300 pb-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-2 font-label text-xs uppercase tracking-[0.2em] text-primary-600">
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            {description}
          </p>
        )}
      </div>
      {linkText && linkTo && (
        <Link
          to={linkTo}
          className="inline-flex shrink-0 items-center gap-1 rounded-md px-3 py-1.5 font-label text-sm text-primary-700 transition-colors hover:bg-primary-50 hover:text-primary-800"
        >
          {linkText}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}